import React from 'react';

export interface ISkeletonComponentProps {
    className?: string;
    width?: string;
    height?: string;
}

const SkeletonComponent: React.FC<ISkeletonComponentProps> = ({ className, width, height }) => {
    const style = {
        '--msc-skeleton-width': width,
        '--msc-skeleton-height': height
    } as React.CSSProperties;

    const skeletonClassName = ['msc-skeleton', className].filter(Boolean).join(' ');

    return <span className={skeletonClassName} style={style} aria-hidden='true' />;
};

export default SkeletonComponent;
